import { mat4 } from 'gl-matrix';
import { DcmJsDatasetWrapper } from './dcmJsWrapper';
import { DicomRegistration } from './dicomRegistration';

export class DicomRigidRegistration extends DicomRegistration {
    public readonly transformation: mat4;

    constructor(
        sopUid: string,
        sourceFrameOfReferenceUid: string,
        targetFrameOfReferenceUid: string,
        contentLabel: string,
        transformation: mat4,
        dataset: DcmJsDatasetWrapper
    ) {
        super(
            sopUid,
            sourceFrameOfReferenceUid,
            targetFrameOfReferenceUid,
            contentLabel,
            dataset
        );
        this.transformation = transformation;
    }
}
